import script from "./ConfirmAbsence.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmAbsence.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmAbsence.vue?vue&type=style&index=0&id=f1ac672a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1ac672a"]])

export default __exports__